export default {
    user: {
        signIn: { method: 'post', url: 'auth' },
        registerWithMobile: { method: 'post', url: 'auth/registerWithMobile' },
        signUpWithOtp: { method: 'post', url: 'auth/processMobileRegister' },
        signOut: { method: 'get', url: 'auth/logout' },
        getOTP: { method: 'post', url: 'auth/sentOtp' },
        signInWithOTP: { method: 'post', url: 'auth/otpLogin' },
        selfOnBoarding: { method: 'post', url: 'fieldEngineer/selfOnBoarding' },
        forgotPassword: { method: 'post', url: 'auth/forgotPassword' },
        changePassword: { method: 'post', url: 'auth/forgotPasswordChange' },
        verifyUser: { method: 'post', url: 'verification/verify/process' },
        userprofile: { method: 'get', url: 'auth' },
        getUserProfile: { method: 'get', url: 'auth/{id}' },
        getSPStatus: { method: 'get', url: 'servicePartner/onBoardingStatus' },
        getFEStatus: { method: 'get', url: 'fieldEngineer/onBoardingStatus' },
        getCustomerStatus: { method: 'get', url: 'customer/isCustomerDetailPending' },
        uploadProfilePic: { method: 'post', url: 'profileImage' },
        updateProfile: { method: 'put', url: 'profile' },
        generateOTP: { method: 'post', url: 'auth/mobileVerifyOTP' },
        verifyOTP: { method: 'post', url: 'auth/mobileVerify' },
        changeAccessLevels: { method: 'post', url: 'assignPermission' },
        authTransactionalToken: { method: 'post', url: 'auth/transactionalToken' },
        googleSignIn: { method: 'post', url: 'auth/authWithGoogle' },
        getUpdateEmail: { method: 'post', url: 'auth/updateMail' },
        uploadIdProofs: { method: 'post', url: 'userProof' },
        newboardingDetails: { method: 'post', url: 'servicePartner/newOnBoarding' },
        skipBankDetails: { method: 'post', url: 'onBoarding/skip' },
        verifyMail: { method: 'post', url: 'verification/mail_verify' },
        updateMailByGoogle: { method: 'post', url: 'auth/updateMailByGoogle' },
        refreshAuthtoken: { method: 'post', url: 'refreshToken' },
        setEmailPwd: { method: 'post', url: 'setUserPwd' },
        saveBankDetails: { method: 'post', url: 'servicePartner/{id}/bank' },
        getBankDetails: { method: 'get', url: 'servicePartner/{id}/bank' }
    },
    invitations: {
        sendInvite: { method: 'post', url: 'invitation/bulk/users' },
        adminSendInvite: { method: 'post', url: 'adminActivity/bulkServicePartners' },
        adminSendCSPInvite: { method: 'post', url: 'customer/spBulkInvite' },
        deleteUser: { method: 'delete', url: 'invitation/user/{userId}' },
        getUsersList: { method: 'get', url: 'invitation/users' },
        setEnalbeDisable: { method: 'get', url: 'invitation/users/{userId}/status/{action}' },
        usersStrengthStatus: { method: 'get', url: 'invitation/users/strengthStatus' },
        reInvite: { method: 'get', url: 'invitation/user/{userId}/inviteMail' },
        inviteFE: { method: 'get', url: 'invitation/user/{feId}/inviteMail' },
        customerSendInvites: { method: 'post', url: 'customer/addOnUserInvite' },
        inviteFEUsingMobile: { method: 'post', url: 'invitation/feInviteOnMobile' },
        inviteCustomersEndUsers: { method: 'post', url: 'customer/inviteEndUser' },
        sendAndroidAppLink: { method: 'post', url: 'invitation/msgAppLink' }
    },
    SP: {
        getAll: { method: 'get', url: 'servicePartner' },
        save: { method: 'post', url: 'servicePartner' },
        updateDetails: { method: 'post', url: 'servicePartner/newOnBoarding' },
        getProfile: { method: 'get', url: 'servicePartner/{id}' },
        getFieldEngineers: { method: 'get', url: 'servicePartner/{id}/fieldEngineers/0' },
        addCities: { method: 'post', url: 'servicePartner/{id}/locations' },
        getExistingCities: { method: 'get', url: 'servicePartner/{id}/locations' },
        verifyPayments: { method: 'post', url: 'servicePartner/{spId}/bank/{bankId}/verify' },
        getEarnings: { method: 'get', url: 'servicePartner/earn' },
        getMonthwiseEarnings: { method: 'get', url: 'servicePartner/monthWiseEarning' },
        listEligibleSPs: { method: 'post', url: 'ticketAssignment/getEligbleSP' },
        acceptTicket: { method: 'post', url: 'ticketAssignment/spAcceptTicket' },
        ignoreTicket: { method: 'post', url: 'ticketAssignment/spIgnoreTicket' },
        dashboardFEList: { method: 'get', url: 'servicePartner/{spId}/fieldEngineers/{status}' },
        dashboardRGGraph: { method: 'get', url: 'servicePartner/performance' },
        dashboardFEPerformanceGraph: { method: 'get', url: 'servicePartner/fieldEngineersPerformance' },
        getCustomersSP: { method: 'get', url: 'customer/{customerId}/servicePartners' },
        getCustomersSPCount: { method: 'get', url: 'customer/{customerId}/userCount' },
        getCustomersAddons: { method: 'get', url: 'customer/{customerId}/addOnUsers' },
        makeProfilePublic: { method: 'post', url: 'servicePartner/convertAsPublic' },
        updateStateDetails: { method: 'post', url: 'servicePartner/{spId}/addStateLocations' },
        updateCustomerStatus: { method: 'post', url: 'servicePartner/underCustomer/{customerId}' },
    },
    FE: {
        onboard: { method: 'post', url: 'fieldEngineer' },
        updateDetails: { method: 'post', url: 'fieldEngineer' },
        getProfile: { method: 'get', url: 'fieldEngineer/{engineerId}' },
        delete: { method: 'delete', url: 'fieldEngineer/{SpId}/{feId}' },
        addCertificates: { method: 'post', url: 'fieldEngineer/{engineerId}/certificates' },
        getCertificates: { method: 'get', url: 'fieldEngineer/{engineerId}/certificates' },
        deleteCertificate: { method: 'delete', url: 'fieldEngineer/{engineerId}/certificates/{certificateId}' },
        listAllTickets: { method: 'get', url: 'fieldEngineer/list/tickets' },
        listMyTickets: { method: 'get', url: 'tickets/getFEAcceptedTickets' },
        acceptOrRejectTicket: { method: 'post', url: 'ticketAssignment/feAcceptRejectTicket' },
        dashboardWeeklyStatus: { method: 'get', url: 'fieldEngineer/{engineerId}/weeklyStatus' },
        dashboardPerformance: { method: 'get', url: 'fieldEngineer/{engineerId}/performance' },
        dashboardPM: { method: 'get', url: 'customer/scm' }
    },
    usecases: {
        getAll: { method: 'get', url: 'usecase' },
        addSPUsecase: { method: 'post', url: 'servicePartner/{id}/usecases' },
        getSPUsecases: { method: 'get', url: 'servicePartner/{id}/usecases' },
    },
    states: {
        listAll: { method: 'get', url: 'states' },
        find: { method: 'get', url: 'states/{stateId}' }
    },
    cities: {
        getAll: { method: 'get', url: 'states/0/city' },
        getFECities: { method: 'get', url: 'fieldEngineer' },
        getStateCities: { method: 'get', url: 'states/{stateId}/city' },
        getCityFromPincode: { method: 'post', url: 'projects/pincodeDetails' }
    },
    banks: {
        getAll: { method: 'get', url: 'banks' },
    },
    tickets: {
        addSites: { method: 'post', url: 'projects/addSitesInProject' },
        addSitesInMultiProject: { method: 'post', url: 'projects/addSitesInProjectMulti' },
        update: { method: 'post', url: 'tickets/editTicket' },
        uploadAdditionalFiles: { method: 'post', url: 'tickets/addFile' },
        viewAdditionalFiles: { method: 'post', url: 'tickets/viewFiles' },
        addBOQ: { method: 'post', url: 'tickets/updateBoq' },
        saveConfigsData: { method: 'post', url: 'configManagement/generateAssetConfigTemplate' },
        boqList: { method: 'get', url: 'tickets/listAllBoqAssets' },
        listNewTickets: { method: 'get', url: 'tickets/getNewTicketList' },
        listCustomerTickets: { method: 'get', url: 'tickets/getScogoAssignedNewTicketList' },
        listTriggeredTickets: { method: 'get', url: 'tickets/getTriggeredTicketList' },
        listPlannedTickets: { method: 'get', url: 'tickets/getPlanningTicketList' },
        listOngoingTickets: { method: 'get', url: 'tickets/getOngoingTicketList' },
        listEscalatedTickets: { method: 'get', url: 'tickets/getEscalatedTicketList' },
        listFavTickets: { method: 'get', url: 'tickets/getFavTicketList' },
        listClosedTickets: { method: 'get', url: 'tickets/getClosedTicketList' },
        listAllTickets: { method: 'get', url: 'tickets/getTicketList' },
        addFavorite: { method: 'post', url: 'tickets/setFavourite' },
        removeFavorite: { method: 'post', url: 'tickets/removeFavourite' },
        viewTicket: { method: 'get', url: 'tickets/viewTicket' },
        getProjectsList: { method: 'get', url: 'tickets/getAllProjectListName' },
        getCount: { method: 'get', url: 'tickets/statusWiseTicketCount' },
        getSPAssignedTicketsCount: { method: 'get', url: 'ticketAssignment/statusWiseTicketCount' },
        getFEAssignedTicketsCount: { method: 'get', url: 'tickets/getFETicketsCount' },
        generateReport: { method: 'get', url: 'projects/{ticketId}/sign_off_generated_report' },
        cloneTicket: { method: 'post', url: 'tickets/cloneTicket' },
        bulkCloneTickets: { method: 'post', url: 'tickets/bulkCloneTicket' },
        bulkEmailReports: { method: 'post', url: 'ticketExecution/bulkEmailReport' },
        updateRLCourierDetails: { method: 'post', url: 'ticketExecution/updateRLTicketStepData' },
        getExecDateChangeRemarks: { method: 'get', url: 'executionDateNotes/comments' },
        editExecutionDate: { method: 'post', url: 'ticketAssignment/editTicketExecutionDate' },
        bulkEditExecutionDate: { method: 'post', url: 'ticketAssignment/bulkEditTicketExecutionDate' },
        getExecDateTimeline: { method: 'post', url: 'executionDateNotes/fetchExecutionDateNotesByTicket' },
        zipTicketReports: { method: 'post', url: 'tickets/zipTicketFiles' },
        getAssetConfigTemplate: { method: 'get', url: 'configManagement/fetchAssetConfigTemplate/{ticketId}' },
        updateTicketAllowance: { method: 'post', url: 'tickets/updateTicketAllowance' },
        getTicketLevelSignOffReportZip: { method: 'get', url: 'tickets/getTicketLevelSignOffReportZip' },
        addTicketLevelSignOffReport: { method: 'post', url: 'tickets/addTicketLevelSignOffReport' },
        addTicketLevelSow: { method: 'post', url: 'tickets/addTicketLevelSow' },
        // SP
        listSPTickets: { method: 'get', url: 'tickets/getSPAcceptedTickets' },
        listSPEligibleTickets: { method: 'get', url: 'ticketAssignment/getEligibleTickets' },
        listSPIgnoredTickets: { method: 'get', url: 'ticketAssignment/spIgnoreTicketList' },
        // Customers
        assignToScogo: { method: 'post', url: 'ticketAssignment/customerAssignToScogo' },
        bulkAssignToScogo: { method: 'post', url: 'ticketAssignment/bulkCustomerAssignToScogo' },
        listCustomerNewTickets: { method: 'get', url: 'tickets/getCustomerNewTicketList' },
        listCustomerTriggeredTickets: { method: 'get', url: 'tickets/getCustomerTriggeredTicketList' },
        listCustomerPlannedTickets: { method: 'get', url: 'tickets/getCustomerPlanningTicketList' },
        listCustomerOngoingTickets: { method: 'get', url: 'tickets/getCustomerOngoingTicketList' },
        listCustomerEscalatedTickets: { method: 'get', url: 'tickets/getCustomerEscalatedTicketList' },
        listCustomerClosedTickets: { method: 'get', url: 'tickets/getCustomerClosedTicketList' },
        listAllCustomerTickets: { method: 'get', url: 'tickets/getCustomerTicketList' },
        getCustomerTicketsCount: { method: 'get', url: 'tickets/statusWiseCustomerTicketCount' },
        customerSignOff: { method: 'post', url: 'tickets/customerSignoffTicketAcceptReject' },
    },
    ticketExecution: {
        broadCastTickets: { method: 'post', url: 'ticketAssignment/broadcastTickets' },
        assignSPManually: { method: 'post', url: 'ticketAssignment/mannualAssignSP' },
        bulkBroadcastTickets: { method: 'post', url: 'ticketAssignment/bulkBroadcastTickets' },
        mannualBulkAssignSP: { method: 'post', url: 'ticketAssignment/mannualBulkAssignSP' },
        reAssignSPManually: { method: 'post', url: 'ticketAssignment/mannualReAssignSP' },
        resumeTicket: { method: 'post', url: 'ticketExecution/resumeTicket' },
        holdTicket: { method: 'post', url: 'ticketExecution/escalateTicket' },
        withdrawTicket: { method: 'post', url: 'tickets/withdrawTicket' },
        hardCloseTicket: { method: 'post', url: 'tickets/hardCloseTicket' },
        assignFE: { method: 'post', url: 'ticketAssignment/spAssignTicket' },
        bulkCustomerAssignFE: { method: 'post', url: 'ticketAssignment/bulkCustomerSPAssignToFE' },
        reAssignFE: { method: 'post', url: 'ticketAssignment/mannualReAssignFE' },
        assignME: { method: 'post', url: 'ticketAssignment/assignToMeTicket' },
        assignTransactionalTicketFE: { method: 'post', url: 'ticketAssignment/spAssignTransactionalTicket' },
        approveSignOff: { method: 'post', url: 'tickets/pmSignoffTicketAccept' },
        rejectSignOff: { method: 'post', url: 'tickets/pmSignoffTicketReject' },
        initiateTicket: { method: 'post', url: 'ticketExecution/reachedSite' },
        getPrequisite: { method: 'post', url: 'ticketExecution/getPreReq' },
        savePrequisite: { method: 'post', url: 'ticketExecution/savePreReq' },
        getFESiteBOQ: { method: 'get', url: 'ticketExecution/getFeSiteBOQ' },
        updateSiteBOQ: { method: 'post', url: 'ticketExecution/updateSiteBOQ' },
        getSteps: { method: 'post', url: 'ticketExecution/getSteps' },
        getStepsFields: { method: 'post', url: 'ticketExecution/getStepsFields' },
        updateStepData: { method: 'post', url: 'ticketExecution/updateStepData' },
        uploadReport: { method: 'post', url: 'ticketExecution/addSignOffReport' },
        closeTicket: { method: 'post', url: 'ticketExecution/signoffTicket' },
        generateReport: { method: 'post', url: 'ticketExecution/generateReport' },
        sendEmailReport: { method: 'post', url: 'ticketExecution/emailReport' },
        getPoStepFields: { method: 'get', url: 'ticketExecution/getPOStepFields' },
        updatePoStepData: { method: 'post', url: 'ticketExecution/updatePOStepData' },
        generatePoReport: { method: 'post', url: 'ticketExecution/generatePOReport' },
        emailPoReport: { method: 'post', url: 'ticketExecution/emailPOReport' },
        delayTicket: { method: 'post', url: 'ticketExecution/delayTicket' },
    },
    projects: {
        create: { method: 'post', url: 'projects/create' },
        createMultiProject: { method: 'post', url: 'projects/createProjectMulti' },
        editProject: { method: 'post', url: 'projects/editProject' },
        projectDetails: { method: 'get', url: 'projects/{projectId}/details' },
        savePreRequisite: { method: 'post', url: 'projects/savePreReq' },
        listOngoingProjects: { method: 'get', url: 'projects/getOngoingProjectList' },
        listFavProjects: { method: 'get', url: 'projects/getFavProjectList' },
        listAllProjects: { method: 'get', url: 'projects/listAll' },
        addFavorite: { method: 'post', url: 'projects/setFavourite' },
        removeFavorite: { method: 'post', url: 'projects/removeFavourite' },
        getCount: { method: 'get', url: 'projects/statusWiseCount' },
        findProjectById: { method: 'post', url: 'projects/findProjectById' },
        getSOWDocument: { method: 'get', url: 'projects/{ticketId}/sow_document' },
        getSignOffSampleReport: { method: 'get', url: 'projects/{ticketId}/sign_off_sample' },
        listCustomerOngoingProjects: { method: 'get', url: 'projects/getCustomerOngoingProjectList' },
        listCustomerAllProjects: { method: 'get', url: 'projects/listAllProjectsByCustomerId' },
        listPrerequisite: { method: 'get', url: 'prerequisite' },
        listAllTemplates: { method: 'post', url: 'projects/templates' },
        bulkUploadProject: { method: 'post', url: 'projects/uploadBulk' },
        bulkUploadSite: { method: 'post', url: 'projects/addBulkSitesInProject' },
        bulkUploadSitesMulti: { method: 'post', url: 'projects/addBulkSitesInProjectMulti' },
        configs: { method: 'get', url: 'configManagement/configs' },
        generateProjectConfig: { method: 'post', url: 'configManagement/generateProjectConfig' },
        getCustomerProjectCount: { method: 'get', url: 'projects/customerProjectCount' },
        addConfigDataInProject: { method: 'post', url: 'configManagement/addConfigDataInProject' },
        createNewTicketConfig: { method: 'post', url: 'configManagement/createNewTicketConfig' },
    },
    partners: {
        stateStrength: { method: 'get', url: 'stateStrength' },
        cityStrength: { method: 'get', url: 'cityStrength/{state}' }
    },
    serviceability: {
        check: { method: 'post', url: 'checkServiceability' }
    },
    payments: {
        listAll: { method: 'get', url: 'tickets/search' },
        listSPwise: { method: 'get', url: 'servicePartner/{userId}/tickets/2' },
        listProjectwise: { method: 'get', url: 'projects/{projectId}/ticketPaymentStatus/2' },
        updateStatus: { method: 'post', url: 'payment/status' }
    },
    remarks: {
        listAll: { method: 'get', url: 'remarks' },
        getEscalationRemarks: { method: 'get', url: 'escalationRemarks' },
        getDelayRemarks: { method: 'get', url: 'delayRemark' },
    },
    endUsers: {
        listAll: { method: 'get', url: 'enduser' },
    },
    customers: {
        listAll: { method: 'get', url: 'customers' },
        onBoard: { method: 'post', url: 'customer' },
        updateDetails: { method: 'put', url: 'customer' },
        getProfile: { method: 'get', url: 'customer/{customerId}' },
        uploadLogo: { method: 'post', url: 'customerLogo' },
        getCustomerDashboardSCMlist: { method: 'get', url: 'customer/scm' },
        getCustomerCardCount: { method: 'get', url: 'customer/{customerId}/todayStatus' },
        getCustomerAvgHoldStatus: { method: 'get', url: 'customer/{customerId}/weeklyStatus' },
        getCustomerWeeklyTicketStatus: { method: 'get', url: 'customer/{customerId}/weeklyTicketStatus' },
        getSlowerTickets: { method: 'get', url: 'customer/{customerId}/projectSlowerTickets/{projectId}' },
        getVendorPerformance: { method: 'get', url: 'customer/{customerId}/vendorsPerformance' },
        getProjectStatus: { method: 'get', url: 'customer/{customerId}/projectStatus/{projectId}' },
        getCustomerServiceType: { method: 'get', url: 'customer/{customerId}/ticketBaseOnSevice' },
        getVendorStatus: { method: 'get', url: 'customer/{customerId}/vendorStatus/{spId}' },
        getPlaningStatus: { method: 'get', url: 'customer/{customerId}/planingStatus' },
        getRevisitStatus: { method: 'get', url: 'customer/{customerId}/revisitStatus' },
        getDelayStatus: { method: 'get', url: 'customer/{customerId}/delayStatus' },
        getNocPerformance: { method: 'get', url: 'customer/{customerId}/nocPerformance' },
        getStateTicketStatus: { method: 'get', url: 'customer/stateTicketStatus' },
    },
    services: {
        listAll: { method: 'get', url: 'services' }
    },
    courier: {
        getVendors: { method: 'get', url: 'courierVendors' },
        trackCourier: { method: 'post', url: 'couriertrack/trackCourier' },
    },
    fcm: {
        mapUser: { method: 'get', url: 'fcm_notification/map_user' }
    },
    procurement: {
        getDemand: { method: 'get', url: 'projects/getDemand' }
    },
    fm: {
        payableList: { method: 'get', url: 'financeManager/accountPayables' },
        spDetails: { method: 'get', url: 'financeManager/servicePartner/{userId}/invoices/0' },
        spDetailsAll: { method: 'get', url: 'financeManager/servicePartner/{userId}/invoices/1' },
        gstStatus: { method: 'post', url: 'financeManager/vendorInvoiceGSTStatus' },
        receivableGenerateInvoiceList: { method: 'get', url: 'financeManager/accountReceivable' },
        receivableProjectTicketsList: { method: 'get', url: 'financeManager/projectTickets' },
        revenuesList: { method: 'get', url: 'financeManager/revenueDetail' },
        paymentsList: { method: 'get', url: 'financeManager/paymentsDetail' },
        revenuesPaymentsTotal: { method: 'get', url: 'financeManager/revenuePaymentsTotal' },
        clients: { method: 'get', url: 'financeManager/clients' },
        vendors: { method: 'get', url: 'financeManager/vendors' },
        dashboardDueClient: { method: 'get', url: 'financeManager/dueClient' },
        dashboardDueVendor: { method: 'get', url: 'financeManager/dueVendor' },
        dashboardCards: { method: 'get', url: 'financeManager/pendingInvoiceCount' },
        dashboardGraph: { method: 'get', url: 'financeManager/revenuePayments' },
        spBankDetails: { method: 'get', url: 'servicePartner/{spId}/bank' },
        spPartnerDetails: { method: 'get', url: 'servicePartnerCompany/{spId}' },
        giDownloadSignOff: { method: 'get', url: 'projects/{ticketId}/sign_off_generated_report' },
        giGenerateInvoice: { method: 'post', url: 'financeManager/generateInvoice/customer' },
        customerInvoicePaymentDate: { method: 'post', url: 'financeManager/customerInvoicePaymentDate' },
        customerInvoiceStatus: { method: 'get', url: 'financeManager/customerInvoiceStatus' },
        spGenerateMonthlyInvoice: { method: 'post', url: 'servicePartner/{spId}/monthlyInvoiceGenerate' },
        spGetMonthlyInvoices: { method: 'get', url: 'servicePartner/{spId}/monthlyInvoices' },
        spDownloadMonthlyInvoice: { method: 'get', url: 'servicePartner/{spId}/monthlyInvoiceDownload/{miId}' },
        spUploadMonthlyInvoice: { method: 'post', url: 'servicePartner/{spId}/monthlyInvoiceUpload/{miId}' },
        spActionMonthlyInvoice: { method: 'post', url: 'servicePartner/{spId}/monthlyInvoiceAction/{miId}' },
        clientGetMonthlyInvoices: { method: 'get', url: 'financeManager/clientInvoices' },
        clientDownloadMonthlyInvoices: { method: 'get', url: 'invoice/customerInvoice/{customer_invoice_id}' },
        updateCustomerInvoiceStatus: { method: 'get', url: 'financeManager/customerInvoiceStatus' }
    },
    pmscmDashboard: {
        weeklyStatus: { method: 'get', url: 'pm/weeklyStatus' },
        projectStatus: { method: 'get', url: 'pm/performance' },
        spTicketAllocation: { method: 'get', url: 'pm/spTicketAllocation' },
        feTicketAllocation: { method: 'get', url: 'pm/feTicketAllocation' },
        activeFE: { method: 'get', url: 'scm/feStateWiseStatus' }
    },
    profile: {
        spProfileDetail: { method: 'get', url: 'servicePartner/{spId}' },
        changeProfileImage: { method: 'post', url: 'profileImage' },
        changePassword: { method: 'post', url: 'auth/changePassword' },
        feProfileDetail: { method: 'get', url: 'fieldEngineer/{feId}' },
        feCertificates: { method: 'get', url: 'fieldEngineer/{feId}/certificates' },
    },
    // notifications: {
    //     //getNotification: { method: 'post', url: 'notifications/get_notifications' },
    //     // readNotification: { method: 'post', url: 'fcm_notification/notification_read_status' }
    // },
    noc: {
        getTemplates: { method: 'get', url: 'projects/getNocTemplates' },
        assignNoc: { method: 'post', url: 'tickets/customerAssignNOC' },
        getEligibleNocs: { method: 'get', url: 'ticketAssignment/getEligbleNOC/{customerId}' },
        getAssignedTicketsList: { method: 'get', url: 'tickets/getNOCTicketList' },
        getAssignedTicketsCount: { method: 'get', url: 'tickets/nocTicketCount' },
        searchTicket: { method: 'post', url: 'tickets/nocTicketSearch' },
        getNocFields: { method: 'get', url: 'ticketExecution/getNocFields' },
        updateNocData: { method: 'post', url: 'ticketExecution/updateNocData' },
        reOpenNocTicket: { method: 'post', url: 'ticketExecution/reOpenNocTicket' },
    },
    scm: {
        getPlanningRemarks: { method: 'get', url: 'tickets/getPlanningRemarks' },
        setPlanningRemarks: { method: 'post', url: 'tickets/setPlanningRemarks' },
        getTools: { method: 'get', url: 'tools' },
        addTools: { method: 'post', url: 'servicePartner/{spId}/updateSiteTools' },
    },
    enduser: {
        // projects
        getOngoingProjectList: { method: 'get', url: 'endUser/getOngoingProjectList' },
        getEndUserProjectCount: { method: 'get', url: 'endUser/endUserProjectCount' },
        getAllProjects: { method: 'get', url: 'endUser/listAllProjects' },
        // tickets
        getStatusWiseTicketCount: { method: 'get', url: 'endUser/statusWiseTicketCount' },
        getNewTicketList: { method: 'get', url: 'endUser/getNewTicketList' },
        getOngoingTicketList: { method: 'get', url: 'endUser/getOngoingTicketList' },
        getClosedTicketList: { method: 'get', url: 'endUser/getClosedTicketList' },
        getTriggeredTicketList: { method: 'get', url: 'endUser/getTriggeredTicketList' },
        getPlanningTicketList: { method: 'get', url: 'endUser/getPlanningTicketList' },
        getEscalatedTicketList: { method: 'get', url: 'endUser/getEscalatedTicketList' },
        getTicketList: { method: 'get', url: 'endUser/getTicketList' },
        // dashboard
        getTodayStatus: { method: 'get', url: 'endUser/todayStatus' },
        getWeeklyTicketStatus: { method: 'get', url: 'endUser/weeklyTicketStatus' },
        getProjectStatus: { method: 'get', url: 'endUser/projectStatus/{project_id}' },
        getProjectSlowerTickets: { method: 'get', url: 'endUser/projectSlowerTickets/{project_id}' },
        getPlanningStatus: { method: 'get', url: 'endUser/planingStatus/{project_id}' },
        getRevisitStatus: { method: 'get', url: 'endUser/revisitStatus/{project_id}' },
        getDelayStatus: { method: 'get', url: 'endUser/delayStatus/{project_id}' }
    },
    wallet: {
        approvePayment: { method: 'post', url: 'payment/walletApprove' }
    },
    admin: {
        getEmailAllTemplates: { method: 'get', url: 'emailTemplates' }
    },
    inventory: {
        bulkUploadSites: { method: 'post', url: 'projects/addBulkSites' },
        bulkUploadAssets: { method: 'post', url: 'projects/addBulkAssets' },
        bulkUploadSpareAssets: { method: 'post', url: 'projects/addBulkSpares' }
    }
}
